import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { Alert } from 'antd';
import { getIn18Text as getTransText } from 'api';
import style from './useLimit24Hour.module.scss';
const ONE_DAY = 24 * 60 * 60 * 1000;
const ONE_HOUR = 60 * 60 * 1000;
const ONE_MINUTE = 60 * 1000;
const ONE_SECOND = 1000;
const getRemainText = (remainTime) => {
    const remainHour = Math.floor(remainTime / ONE_HOUR);
    const remainMinute = Math.floor((remainTime - remainHour * ONE_HOUR) / ONE_MINUTE);
    const remainSecond = Math.floor((remainTime - remainHour * ONE_HOUR - remainMinute * ONE_MINUTE) / ONE_SECOND);
    return (React.createElement(React.Fragment, null,
        getTransText('li24hgoutongshixiaohaisheng'),
        React.createElement("span", { className: style.remainingTime }, `${remainHour.toString().padStart(2, '0')}h:${remainMinute.toString().padStart(2, '0')}m:${remainSecond.toString().padStart(2, '0')}s`),
        getTransText('ninkeyifasongrenyixiaoxichudakehu')));
};
const AlertComp = ({ time, exceeded, onExceededChange }) => {
    const [exceededText, setExceededText] = useState('');
    const [remainingText, setRemainingText] = useState('');
    useEffect(() => {
        if (!time) {
            onExceededChange(true);
            setExceededText(getTransText('DUIFANGHUIFUHOUCAIKEYIFASONGXIAOXI'));
            setRemainingText('');
        }
        else {
            const handler = () => {
                const remainTime = time + ONE_DAY - Date.now();
                if (remainTime < 0) {
                    onExceededChange(true);
                    setExceededText(getTransText('CHAOCHU24HGOUTONGSHIXIAO'));
                    setRemainingText('');
                }
                else {
                    onExceededChange(false);
                    setExceededText('');
                    setRemainingText(getRemainText(remainTime));
                }
            };
            handler();
            const interval = setInterval(handler, 1000);
            return () => interval && clearInterval(interval);
        }
    }, [time]);
    return exceeded ? (React.createElement(Alert, { className: classnames(style.alert, style.disabled), message: exceededText, type: "warning", showIcon: true })) : (React.createElement(Alert, { className: style.alert, message: remainingText, type: "warning", showIcon: true }));
};
function useLimit24Hour(time) {
    const [exceeded, setExceeded] = useState(false);
    return {
        exceeded,
        alert: React.createElement(AlertComp, { time: time, exceeded: exceeded, onExceededChange: setExceeded }),
    };
}
export { useLimit24Hour };
